/**
 * WithingsTrendsPage - Route-Komponente für Trends Tab
 * Wrapper um TrendsTab mit Router-Integration
 */

import React from "react";

import { useWithingsData } from "../../hooks/useWithingsData";
import { TrendsTab } from "./TrendsTab";

export const WithingsTrendsPage: React.FC = () => {
  const { isLoadingMeasurements, measurements } = useWithingsData();

  return <TrendsTab isLoading={isLoadingMeasurements} measurements={measurements} />;
};
